import axios from "axios";
import { SERVERPATH } from "./index";

const ConfigPath = `${SERVERPATH}/config`;

export async function getConfig(configType) {
    let params = {
        "config_type": configType,
    };

    const response = await axios.get(`${ConfigPath}/`, { params });

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    const { status: ocStatus, data } = responseData;

    if (ocStatus !== 200) {
        throw responseData;
    }

    return data;
}
